export default [
  // {
  //   path: '/mantra/list',
  //   name: 'mantra-list',
  //   component: () => import('@/views/mantra/index.vue'),
  //   meta: {
  //     allowAnonymous: false,
  //     pageTitle: 'Mantra List',
  //     breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Mantra' }, { title: 'Mantra List', active: true }],
  //     permissions: ['mantra_list']
  //   }
  // },
  {
    path: '/mantra/add',
    name: 'create-mantra',
    component: () => import('@/views/mantra/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Update Mantra',
      parent: 'MantraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Mantra', url: '/mantra/add' },
        { title: 'Update Mantra', active: true }
      ],
      permissions: ['mantra_edit']
    }
  }
  // {
  //   path: '/mantra/:id/edit',
  //   name: 'edit-mantra',
  //   component: () => import('@/views/mantra/action.vue'),
  //   meta: {
  //     allowAnonymous: false,
  //     pageTitle: 'Edit Mantra',
  //     parent: 'MantraList',
  //     // breadcrumb: [
  //     //   { title: 'Dashboard', url: '/dashboard' },
  //     //   { title: 'Mantra', url: '/mantra/list' },
  //     //   { title: 'Edit Mantra', active: true }
  //     // ],
  //     permissions: ['mantra_edit']
  //   }
  // }
]
